import { useContext, useEffect, useState } from "react";
import ExpandModal from "@modals/ExpandModal";
import { Button, Select, Space, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { IMainContext, ITagTypeAggregate } from "@/ts/common-types";
import { map } from "underscore";
import { agBtnExport } from "@/ts/utils";
import { mainContext } from "@/ts/constants";
import { setSelectedTagTypeOption } from "@/features/gridDataSlice";
import TagTypeAggregateGrid from "./TagTypeAggregateGrid";
import { GridApi } from "ag-grid-community";
import ExportGridBtn from "@/components/buttons/ExportGridBtn";

const { Option } = Select;

const TagTypeAggregate = () => {
    const modalTitle = "Aggregated View";
    const [show, setShow] = useState(false);
    const dispatch = useDispatch();

    const [tagTypeAggregatedGridApi, setTagTypeAggregatedGridApi] = useState<GridApi | null>(null);

    const { setTagTypeAggregatedGridLoading } = useContext<IMainContext>(mainContext);

    const [percentTaggedCampaigns, setPercentTaggedCampaigns] = useState<number>(0);

    const tagTypeAggregatedData = useSelector(
        (state: { tagTypeAggregatedData: { value: ITagTypeAggregate[] } }) =>
            state.tagTypeAggregatedData.value
    );

    const tagTypeOptions = useSelector(
        (state: { tagTypeOptions: { value: string[] } }) =>
            state.tagTypeOptions.value
    );

    const selectedTagTypeOption = useSelector(
        (state: { selectedTagTypeOption: { value: string } }) =>
            state.selectedTagTypeOption.value
    );

    const campaignLevelTotalSpend = useSelector(
        (state: { campaignLevelTotalSpend: { value: number } }) =>
            state.campaignLevelTotalSpend.value
    );

    const tagTypeLevelTotalSpend = useSelector(
        (state: { tagTypeLevelTotalSpend: { value: number } }) =>
            state.tagTypeLevelTotalSpend.value
    );

    const handleTagTypeOptionChange = (value: string) => {
        setTagTypeAggregatedGridLoading(true);

        dispatch(setSelectedTagTypeOption(value));

        setTagTypeAggregatedGridLoading(false);
    }

    useEffect(() => {
        if (tagTypeLevelTotalSpend && campaignLevelTotalSpend) {
            setPercentTaggedCampaigns(
                +(
                    (campaignLevelTotalSpend - tagTypeLevelTotalSpend) * 100 /
                    campaignLevelTotalSpend
                ).toFixed(2)
            );
        }
    }, [tagTypeLevelTotalSpend, campaignLevelTotalSpend]);

    return (
        <>
            <div
                className="card h-100 mb-4 shadow"
                style={{ borderRadius: "16px" }}
            >
                <div className="card-body p-2" style={{ borderRadius: "16px" }}>
                    <div className="d-flex align-items-center justify-content-between px-2 pt-1">
                        <h5>{modalTitle}</h5>
                        <Space
                            style={{
                                display: tagTypeAggregatedData?.length
                                    ? "flex"
                                    : "none",
                            }}
                        >
                            {percentTaggedCampaigns > 1 && (
                                <Tag
                                    color="error"
                                    style={{
                                        margin: 0,
                                        borderRadius: 8,
                                        display: "flex",
                                        alignItems: "center",
                                        height: 35,
                                        gap: "4px",
                                    }}
                                >
                                    {`${percentTaggedCampaigns}% campaigns not tagged`}
                                </Tag>
                            )}
                            <Select
                                onChange={handleTagTypeOptionChange}
                                value={selectedTagTypeOption}
                                placeholder="Select tag type"
                                style={{
                                    width: 130,
                                }}
                            >
                                {map(tagTypeOptions, (type) => (
                                    <Option key={type} value={type}>
                                        {type}
                                    </Option>
                                ))}
                            </Select>
                            <ExportGridBtn onClickFunction={() => agBtnExport(tagTypeAggregatedGridApi, true, `${selectedTagTypeOption} View`)}
                                isSubModule={true} />
                        </Space>
                    </div>
                    <div className="border-top pt-2 mt-2">
                        <TagTypeAggregateGrid
                            gridApi={tagTypeAggregatedGridApi}
                            setGridApi={setTagTypeAggregatedGridApi}
                        />
                    </div>
                </div>
            </div>
            <ExpandModal
                show={show}
                setShow={setShow}
                modalTitle={modalTitle}
            />
        </>
    );
};

export default TagTypeAggregate;


